
// Please remove this code once the ‘Buy 3 at 999’ discount has been removed.
/**
 * Cart Special Pricing - 3 Items for ₹999
 * BALANCED MODE - Updates price correctly without breaking GoKwik
 * Strategy: Watch quantity changes BUT delay update until AFTER GoKwik finishes
 */

(function() {
  'use strict';

  // ============================================
  // CONFIGURATION
  // ============================================
  const CONFIG = {
    specialQuantity: 3,
    specialPrice: '₹999.00',
    
    selectors: {
      cartDrawer: '#CartDrawer, cart-drawer',
      cartCount: 'cart-count, .count',
      totalPrice: '.totals__subtotal-value',
      cartFooter: '.drawer__footer-bottom',
      lineItems: '.horizontal-product',
      quantityInputs: 'input[type="number"][name="updates[]"]'
    },
    
    styling: {
      totalPriceColor: '#008060',
      showBadge: true,
      badgeText: '🎉 Special Offer: Buy 3 Items for Just ₹999!'
    },
    
    // Timing to avoid GoKwik conflicts
    timing: {
      afterQuantityChange: 1500,  // Wait 1.5 seconds after quantity change (GoKwik finishes first)
      afterDrawerOpen: 800,        // Wait 800ms after drawer opens
      afterCartUpdate: 1200        // Wait 1.2 seconds after cart update events
    }
  };

  let updateTimer = null;
  let lastQuantity = null;

  // ============================================
  // MAIN FUNCTIONS
  // ============================================

  /**
   * Get current cart item count
   */
  function getCartItemCount() {
    // Method 1: From cart count badge
    const cartCountElement = document.querySelector(CONFIG.selectors.cartCount);
    if (cartCountElement && !cartCountElement.hasAttribute('hidden')) {
      const count = parseInt(cartCountElement.textContent.trim());
      if (!isNaN(count) && count > 0) {
        console.log('✓ Cart count from badge:', count);
        return count;
      }
    }

    // Method 2: Count line items and their quantities
    const lineItems = document.querySelectorAll(CONFIG.selectors.lineItems);
    if (lineItems.length > 0) {
      let totalQty = 0;
      lineItems.forEach(item => {
        const qtyInput = item.querySelector('input[type="number"][name="updates[]"]');
        if (qtyInput) {
          const qty = parseInt(qtyInput.value) || 0;
          totalQty += qty;
        }
      });
      if (totalQty > 0) {
        console.log('✓ Cart count from line items:', totalQty);
        return totalQty;
      }
    }

    // Method 3: Try to count from cart API
    return 0;
  }

  /**
   * Update display with delay to avoid GoKwik conflicts
   */
  function scheduleUpdate(delay) {
    // Clear any pending update
    if (updateTimer) {
      clearTimeout(updateTimer);
    }

    console.log('⏱️ Scheduling update in', delay + 'ms');

    // Schedule update after GoKwik finishes
    updateTimer = setTimeout(function() {
      updateCartDisplay();
    }, delay);
  }

  /**
   * Update the cart display
   */
  function updateCartDisplay() {
    const itemCount = getCartItemCount();
    
    console.log('🔍 Checking - Items:', itemCount, '| Special Qty:', CONFIG.specialQuantity);

    // Only update if quantity actually changed
    if (itemCount === lastQuantity) {
      console.log('⏭️ Quantity unchanged, skipping');
      return;
    }

    lastQuantity = itemCount;

    if (itemCount === CONFIG.specialQuantity) {
      console.log('✅ Special pricing activated!');
      updateTotalPrice();
      if (CONFIG.styling.showBadge) {
        addSpecialBadge();
      }
    } else {
      console.log('❌ Special pricing not applicable');
      removeSpecialBadge();
      // Let normal price show
    }
  }

  /**
   * Update the total price display
   */
  function updateTotalPrice() {
    const totalElement = document.querySelector(CONFIG.selectors.totalPrice);
    
    if (totalElement) {
      console.log('💰 Found total element, updating...');
      totalElement.textContent = CONFIG.specialPrice;
      totalElement.style.color = CONFIG.styling.totalPriceColor;
      console.log('✅ Price updated to:', CONFIG.specialPrice);
      
      // Mark element to track we changed it
      totalElement.setAttribute('data-special-price', 'true');
    } else {
      console.warn('⚠️ Total price element not found');
      
      // Try alternative selectors
      const alternatives = [
        '.totals .font-bold',
        '.drawer__footer-bottom .font-bold',
        '[class*="total"] [class*="font-bold"]'
      ];
      
      for (let selector of alternatives) {
        const elem = document.querySelector(selector);
        if (elem && elem.closest('.totals')) {
          console.log('✓ Using alternative selector:', selector);
          elem.textContent = CONFIG.specialPrice;
          elem.style.color = CONFIG.styling.totalPriceColor;
          elem.setAttribute('data-special-price', 'true');
          break;
        }
      }
    }
  }

  /**
   * Add special offer badge
   */
  function addSpecialBadge() {
    if (document.querySelector('.js-special-price-badge')) {
      return;
    }

    const footer = document.querySelector(CONFIG.selectors.cartFooter);
    if (!footer) return;

    const badge = document.createElement('div');
    badge.className = 'js-special-price-badge';
    badge.style.cssText = `
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      padding: 14px 18px;
      border-radius: 10px;
      margin-bottom: 16px;
      text-align: center;
      font-weight: 700;
      font-size: 15px;
      box-shadow: 0 4px 16px rgba(102, 126, 234, 0.4);
      letter-spacing: 0.3px;
      pointer-events: none;
      user-select: none;
      animation: slideIn 0.4s ease-out;
    `;
    badge.innerHTML = CONFIG.styling.badgeText;

    // Add animation
    if (!document.getElementById('special-price-animation')) {
      const style = document.createElement('style');
      style.id = 'special-price-animation';
      style.textContent = `
        @keyframes slideIn {
          from { opacity: 0; transform: translateY(-15px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `;
      document.head.appendChild(style);
    }

    footer.insertBefore(badge, footer.firstChild);
    console.log('✅ Special badge added');
  }

  /**
   * Remove special offer badge
   */
  function removeSpecialBadge() {
    const badge = document.querySelector('.js-special-price-badge');
    if (badge) {
      badge.remove();
      console.log('✅ Special badge removed');
    }
  }

  // ============================================
  // EVENT LISTENERS - DELAYED TO AVOID GOKWIK
  // ============================================

  function setupListeners() {
    const drawer = document.querySelector(CONFIG.selectors.cartDrawer);
    
    if (!drawer) {
      console.warn('⚠️ Cart drawer not found, retrying...');
      setTimeout(setupListeners, 1000);
      return;
    }

    console.log('✅ Cart drawer found, setting up listeners...');

    // 1. Watch for drawer opening
    const drawerObserver = new MutationObserver(function(mutations) {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'hidden') {
          if (!drawer.hasAttribute('hidden')) {
            console.log('📂 Drawer opened');
            scheduleUpdate(CONFIG.timing.afterDrawerOpen);
          } else {
            console.log('📁 Drawer closed - resetting');
            lastQuantity = null;
          }
        }
      });
    });

    drawerObserver.observe(drawer, {
      attributes: true,
      attributeFilter: ['hidden']
    });

    // 2. Watch for quantity input changes (but update AFTER GoKwik)
    document.addEventListener('input', function(e) {
      if (e.target.matches(CONFIG.selectors.quantityInputs)) {
        console.log('🔢 Quantity input changed');
        // Schedule update AFTER GoKwik finishes its refresh
        scheduleUpdate(CONFIG.timing.afterQuantityChange);
      }
    });

    // 3. Watch for cart update events (delayed)
    const cartEvents = ['cart:updated', 'cart:refresh'];
    cartEvents.forEach(function(eventName) {
      document.addEventListener(eventName, function() {
        console.log('📢 Cart event:', eventName);
        scheduleUpdate(CONFIG.timing.afterCartUpdate);
      });
    });

    // 4. Observe cart content changes (delayed reaction)
    const cartObserver = new MutationObserver(function(mutations) {
      const hasRelevantChange = mutations.some(function(mutation) {
        return mutation.target.matches && 
               (mutation.target.matches(CONFIG.selectors.lineItems) ||
                mutation.target.closest(CONFIG.selectors.lineItems));
      });

      if (hasRelevantChange) {
        console.log('🔄 Cart content changed');
        scheduleUpdate(CONFIG.timing.afterQuantityChange);
      }
    });

    cartObserver.observe(drawer, {
      childList: true,
      subtree: true
    });

    console.log('✅ All listeners attached with delayed updates');
    console.log('⏱️ Delays configured:');
    console.log('   - After quantity change:', CONFIG.timing.afterQuantityChange + 'ms');
    console.log('   - After drawer open:', CONFIG.timing.afterDrawerOpen + 'ms');
    console.log('   - After cart update:', CONFIG.timing.afterCartUpdate + 'ms');
  }

  // ============================================
  // INITIALIZATION
  // ============================================

  function init() {
    console.log('🛒 Cart Special Pricing - BALANCED MODE');
    console.log('⚖️ Updates price correctly + Avoids GoKwik conflicts');
    console.log('⏱️ Uses delayed updates after GoKwik finishes');
    
    // Initial setup
    setTimeout(setupListeners, 500);
    
    // If drawer is already open on page load
    setTimeout(function() {
      const drawer = document.querySelector(CONFIG.selectors.cartDrawer);
      if (drawer && !drawer.hasAttribute('hidden')) {
        console.log('📂 Drawer already open on page load');
        scheduleUpdate(CONFIG.timing.afterDrawerOpen);
      }
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Manual trigger
  window.updateCartSpecialPrice = function() {
    console.log('🔧 Manual update triggered');
    updateCartDisplay();
  };
  
  window.getCartItemCount = getCartItemCount;

  console.log('💡 Manual trigger: window.updateCartSpecialPrice()');
  console.log('💡 Check count: window.getCartItemCount()');

})();